import React, { PureComponent } from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';

/**
 * for this page
 */
const Qrcode = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.object,
        };

        state = {
            qrClass: true, // 二维码样式名,true为当前样式
            qrDisplay: false, // 二维码是否显示
        };
        componentDidMount() {
            window.addEventListener('resize', this.onWindowResize);
        }
        componentWillUnmount() {
            window.removeEventListener('resize', this.onWindowResize);
        }
        // 页面尺寸变化
        onWindowResize = () => {
            // console.log('size==', document.documentElement.clientHeight);
            if (document.documentElement.clientHeight < 650) {
                this.setState({
                    qrClass: false,
                });
            } else {
                this.setState({
                    qrClass: true,
                });
            }
            if (document.documentElement.clientWidth < 1240) {
                this.setState({
                    qrDisplay: true,
                });
            } else {
                this.setState({
                    qrDisplay: false,
                });
            }
        };
        render() {
            // const displayValue = this.props.qrDisplay;
            // const codeClass = this.props.qrClass;
            const { qrClass, qrDisplay } = this.state;
            const { content } = this.props;

            return (
                <div
                    className={
                        qrClass ? `${styles.qrCode} ${styles.current_code}` : `${styles.qrCode} ${styles.bottom_code}`
                    }
                    style={{ display: qrDisplay ? 'none' : 'block' }}
                    id="qr_code">
                    <img src={content.qrcodePic} alt="" width="98" height="98" />
                    <p>{content.titlePic}</p>
                </div>
            );
        }
    },
);

export { Qrcode };
export default Qrcode;
